import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-arc-primary focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--arc-cyan-primary)] text-white",
        secondary:
          "border-transparent bg-arc-panel-soft text-arc-text-main",
        outline: "text-arc-text-main border-arc-border",
        chip: "border-white/10 bg-white/[0.06] font-medium text-arc-text-muted backdrop-blur-sm",
        gold: "border-transparent bg-[var(--arc-gold-primary)] text-arc-bg shadow-[0_0_10px_var(--arc-gold-glow)]",
        achievement: "border-transparent bg-[var(--arc-gold-primary)] text-arc-bg shadow-[0_0_15px_var(--arc-gold-glow)] font-semibold",
        creator: "border-transparent bg-[var(--arc-purple-creator)] text-white",
        danger: "border-transparent bg-[var(--arc-danger)] text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

// eslint-disable-next-line react-refresh/only-export-components -- cva variant map used by callers
export { Badge, badgeVariants }

